var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInventoryNormalOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 55,
    height: 55,
    rx: 7,
    fill: "none",
    stroke: "#2D8DD2",
    strokeWidth: 3.75
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.82 -2.51) scale(0.973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 50H38",
    strokeLinecap: "round",
    fill: "none",
    stroke: "#2D8DD2",
    strokeWidth: 3.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 43.1517C37.2634 43.1517 43.1515 37.2635 43.1515 30.0001C43.1515 22.7368 37.2634 16.8486 30 16.8486C22.7366 16.8486 16.8485 22.7368 16.8485 30.0001C16.8485 37.2635 22.7366 43.1517 30 43.1517Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#2D8DD2",
    strokeWidth: 3.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9388 29.6356L29.0667 33.8144L35.0612 26.1865",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    stroke: "#2D8DD2",
    strokeWidth: 3.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventoryNormalOutline);
export default __webpack_public_path__ + "static/media/icon-inventory-normal-outline.a08aa25083f4404e16095d73353b98e3.svg";
export { ForwardRef as ReactComponent };